<script>
	import UpdateAvailable from "./pages/UpdateAvailable.svelte";
	import { updateApp } from "./store.js";
	import ModalNotInPreview from "./pages/ModalNotInPreview.svelte";
	import Lazy from "./pages/Lazy.svelte";
	import TabMenu from "./components/tabmenu/TabMenu.svelte";
	import SideBar from "./components/sidebar/SideBar.svelte";
	import {
		currentView,
		drawerOpen,
		navbarMenu,
		prevView,
		showBack,
		back,
		currentViewObject,
		navbarTitle,
		notInPreview,
		showNavbarImage,
		iframeConfig,
	} from "./store";
	import WebFont from "webfontloader";
	import { onMount, tick } from "svelte";
	import Header from "./components/header/Header.svelte";
	import IframeView from "./pages/IframeView.svelte";
	import {
		AddURLResultWindow,
		AddURLResult,
		checkWindowURL,
		checkIframeURL,
		iframeCheck,
		checkDataForUrls,
	} from "./init";

	export let id = 0;
	let backNum = 0;
	let vid = 0;
	let firstLoad = true;
	let webapp = false; //window.matchMedia('(display-mode: standalone)').matches && idevice && !pg;

	if (menuType === "left_panel") {
		navbarMenu.set(true);
		backNum = appMenu.length - 1;
	}

	if (menuType === "tabs") {
		backNum = appMenu.slice(0, 5).length - 1;
	}

	let ready = false;
	let iOS = false;

	onMount(() => {
		if (navBarImage && $currentView === 0) {
			showNavbarImage.set(true);
		} else {
			showNavbarImage.set(false);
		}

		if (location.hash !== "#0" && location.hash !== "") {
			console.log("set page");
			const vid = Number(getViewId(location.hash));
			console.log(vid);
			const v = views.find((x) => x.id === vid);

			currentViewObject.set(v);
			currentView.set(vid);
			if (navBarImage && vid === 0) {
				showNavbarImage.set(true);
			} else {
				showNavbarImage.set(false);
			}
			let inMenu = inMenuCheck(vid);

			if (!inMenu) {
				showBack.set(true);
			} else {
				if (menuType !== "tabs" && menuType !== "left_panel") {
					showBack.set(true);
				}
			}
			prevView.set(0);
		}

		ready = true;

		if (menuType === "left_panel" || menuType === "tabs") {
			setTimeout(() => {
				checkDataForUrls(appMenu, menuType);
			}, 1000);
		}
	});

	async function locationHashChanged() {
		try {
			console.log("hash change");
			console.log(location.hash);
			vid = Number(getViewId(location.hash));

			const v = views.find((x) => x.id === vid);

			currentViewObject.set(v);

			let inMenu = inMenuCheck(vid);
			let useSlide =
				menuType !== "left_panel" ||
				((inMenu === false || (inMenu && $back)) &&
					menuType === "left_panel");

			//close sidebar
			if ($drawerOpen && !inMenu) {
				drawerOpen.set(false);
				await tick();
			}

			if (menuType === "tabs") {
				if (vid < Number($currentView)) {
					back.set(true);
					console.log("tab back slide");
				}
			}

			firstLoad = false;

			console.log("prev " + $currentView);

			prevView.set($currentView);
			currentView.set(vid);
			await tick();

			if (navBarImage && vid === 0) {
				showNavbarImage.set(true);
			} else {
				showNavbarImage.set(false);
			}

			console.log("in menu:" + inMenu);
			console.log("use slide:" + useSlide);
			//not in drawer and part of menu
			if (useSlide) {
				console.log("slide");
				if (!$back) {
					animateCSS($currentView, "slideIn", "");
					animateCSS($prevView, "slideOut", "");
				} else {
					animateCSS($currentView, "slideInBack", "");
					animateCSS($prevView, "slideOutBack", "");
				}
			} else {
				console.log("no slide ");
				//remove hide class
				const hidden = document.getElementById($prevView);
				hidden.classList.remove("hide");
			}

			if ($currentView === -1) {
				//iframe action
				navbarTitle.set($iframeConfig.title);
			} else {
				//not iframe
				navbarTitle.set($currentViewObject.t);
				iframeConfig.set(null);
			}

			if ($back) {
				back.set(false);
			}
			//determine back
			if (useSlide) {
				setTimeout(() => {
					if (showBackCheck(vid, inMenu)) {
						showBack.set(true);
					} else {
						showBack.set(false);
					}
				}, 250);
			} else {
				if (showBackCheck(vid, inMenu)) {
					showBack.set(true);
				} else {
					showBack.set(false);
				}
			}
		} catch (err) {
			console.log(err);
			console.log(vid);
			console.log($prevView);
		}
	}

	function showBackCheck(id, inMenu) {
		let result = true;

		switch (menuType) {
			case "left_panel":
				if (inMenu) {
					result = false;
				} else {
					if (Number(id) === Number(0)) {
						result = false;
					}
				}
				break;
			case "tabs":
				if (inMenu) {
					result = false;
				} else {
					if (Number(id) === Number(0)) {
						result = false;
					}
				}
				break;
			default:
				if (Number(id) === 0) {
					result = false;
				}
				break;
		}
		return result;
	}

	function inMenuCheck(id) {
		let result = false;

		switch (menuType) {
			case "tabs":
				if (
					appMenu
						.slice(0, 5)
						.find((x) => Number(x.id) === Number(id)) !== undefined
				) {
					result = true;
				}
				break;
			default:
				if (
					appMenu.find((x) => Number(x.id) === Number(id)) !==
					undefined
				) {
					result = true;
				}
				break;
		}
		console.log(menuType);
		console.log(result);
		return result;
	}

	function getViewId(hash) {
		if (hash && hash.includes("#")) {
			return hash.split("#")[1];
		} else {
			return hash;
		}
	}

	window.onhashchange = locationHashChanged;

	const Fontbase = "https://igappblobs.azureedge.net/public/fonts/kits/";
	console.log("Start Font loading");
	console.log(fontsNeeded);

	const wofffile = "woff2";

	if (fontsNeeded !== undefined) {
		if (fontsNeeded.indexOf("igenapps") < 0) {
			//add basic font
			fontsNeeded.push("igenapps");
		}

		const FontPaths = [
			{ f: "igenapps", u: "06e699e1" },
			{ f: "business", u: "7fae2a24" },
			{ f: "food", u: "f9636f27" },
			{ f: "fun", u: "24b2ce2b" },
			{ f: "health-fitness", u: "ededacae" },
			{ f: "home", u: "740190b0" },
			{ f: "location-weather", u: "ae01d74c" },
			{ f: "media", u: "9e7ed6fd" },
			{ f: "misc", u: "3739adb5" },
			{ f: "transportation", u: "e17b0989" },
			{ f: "general", u: "f28fdff0" },
			{ f: "general2", u: "f28fdff0" },
			{ f: "igenkit", u: "fb406583" },
			{ f: "ss-symbolicons-line", u: "71601598" },
		];
		FontPaths.forEach((fp) => {
			if (fontsNeeded.indexOf(fp.f) > -1) {
				console.log("font requested " + fp.f);

				let font = "";
				switch (fp.f) {
					case "igenapps":
						font = "igenapps";
						break;
					case "location-weather":
						font = "igen-location";
						break;
					case "transportation":
						font = "igen-transport";
						break;
					case "health-fitness":
						font = "igen-health";
						break;
					case "igenkit":
						font = "igen-kit";
						break;
					case "ss-symbolicons-line":
						font = "ss-symbolicons-line";
						break;
					default:
						font = "igen-" + fp.f;
						break;
				}

				WebFont.load({
					custom: {
						families: [font],
						urls: [Fontbase + fp.u + "/" + wofffile + ".css"],
					},
				});
			}
		});
	}

	window.showNotInPreviewMessage = () => {
		notInPreview.set(true);
	};

	window.showBackIcon = () => {
		showBack.set(true);
	};

	window.hideBackIcon = () => {
		showBack.set(true);
	};

	window.OpenIframeOrNot = async (url, title, direct) => {
		console.log("attempt iframe");
		console.log(url);
		console.log(title);
		console.log(direct);
		const curView = $currentView;

		if (checkWindowURL(url)) {
			console.log("external");
			return ExternalRefOpen(url);
		}

		//load loader
		iframeConfig.set({
			url: url.replace("http://", "https://"),
			title: title,
			direct: direct,
		});
		location.hash = -1;

		//continue check

		if (
			$iframeConfig.url.toLowerCase().includes("instagram.") ||
			$iframeConfig.url.toLowerCase().includes("facebook.")
		) {
			//window.history.back($iframeConfig.url);
			location.hash = curView;
			return ExternalRefOpen($iframeConfig.url);
		}

		if (checkIframeURL($iframeConfig.url)) {
		} else {
			const url = $iframeConfig.url;
			//window.history.back();
			location.hash = curView;
			if (pg) {
				if (
					getParameterByName("native") > 0 ||
					getParameterByName("nativepush") > 0
				) {
					console.log(url);
					OpenPhoneGapLinkinAppThemed(url, userColor);
				} else {
					console.log(url);
					OpenPhoneGapLinkinApp(url);
				}
			} else {
				console.log("external");
				ExternalRefOpen(url);
			}

			if (!checkWindowURL(url)) {
				const result = await iframeCheck(url);
				if (result) {
					AddURLResult(url);
				} else {
					AddURLResultWindow(url);
				}
			}
		}
	};

	const animateCSS = (element, animation, prefix = "animate__") =>
		new Promise((resolve, reject) => {
			console.log(element + " animation");
			const animationName = `${prefix}${animation}`;
			const node = document.getElementById(element);

			node.classList.add(`${prefix}animated`, animationName);

			// When the animation ends, we clean the classes and resolve the Promise
			function handleAnimationEnd(event) {
				event.stopPropagation();

				node.classList.remove(
					`${prefix}animated`,
					animationName,
					"hide",
				);

				resolve("Animation ended");
				console.log("animation done");
			}

			node.addEventListener("animationend", handleAnimationEnd, {
				once: true,
			});
		});

	function showBackgroundImage(id) {
		if (
			backgroundImage &&
			id === 0 &&
			(menuType === "grid" || menuType === "list")
		) {
			console.log("background " + backgroundImage);
			return " background-image";
		} else {
			return "";
		}
	}
</script>

{#if ready}
	{#if menuType === "left_panel"}
		<SideBar links={appMenu} />
	{/if}

	<div
		class="views {$drawerOpen === true ? 'drawerOpen' : ''}"
		style="background-color:{appBackground.hexBackground};"
	>
		<Header {webapp} />

		{#if menuType !== "tabs"}
			{#each views as view}
				<div
					id={view.id}
					class="view{firstLoad && view.id === 0
						? ' init'
						: ''}{$currentView === view.id
						? ' active'
						: ''}{$prevView === view.id
						? ' hide'
						: ''}{showBackgroundImage(view.id)}"
					data-template={view.c}
					style="background-color:{appBackground.hexBackground};"
					class:webapp
				>
					<Lazy {view} />
				</div>
			{/each}

			<div
				id={-1}
				class="view {$currentView === -1 ? ' active' : ''}{$prevView ===
				-2
					? ' hide'
					: ''}"
				data-template="iframe"
				style="background-color:{appBackground.hexBackground};"
			>
				{#if $iframeConfig}
					<IframeView />
				{/if}
			</div>
		{:else}
			<TabMenu title={"Tab Menu"} back={false} animateIt={false}>
				{#each views as view}
					<div
						id={view.id}
						class="view tab-panel {firstLoad && view.id === 0
							? ' init'
							: ''}{$currentView === view.id
							? ' active'
							: ''}{$prevView === view.id ? ' hide' : ''}"
						data-template={view.c}
						style="background-color:{appBackground.hexBackground};"
						class:webapp
					>
						<Lazy {view} />
					</div>
				{/each}

				<div
					id={-1}
					class="view {$currentView === -1
						? ' active'
						: ''}{$prevView === -2 ? ' hide' : ''}"
					data-template="iframe"
					style="background-color:{appBackground.hexBackground};"
				>
					{#if $iframeConfig !== null}
						<IframeView />
					{/if}
				</div>
			</TabMenu>
		{/if}
	</div>

	{#if $notInPreview}
		<ModalNotInPreview />
	{/if}

	{#if $updateApp}
		<UpdateAvailable />
	{/if}
{/if}

<style>
	.view {
		position: absolute;
		height: calc(100% - 50px);
		min-height: calc(100% - 50px);
		width: 100%;
		min-width: 100%;
		top: 50px;
		left: 0;
		visibility: hidden;
		display: none;
		/* transform: translate3d(100%,0,0) scale(1);  */
	}
	.view.webapp {
		top: 75px;
		height: calc(100% - 75px);
		min-height: calc(100% - 75px);
	}
	.view.tab-panel {
		height: calc(100% - 125px);
		min-height: calc(100% - 125px);
	}
	.view.tab-panel.webapp {
		height: calc(100% - 150px);
		min-height: calc(100% - 150px);
	}

	.view.init {
		transform: none !important;
		visibility: visible;
		display: block;
	}

	.view.active {
		/* transform: translate3d(-100%, 0px, 0px) scale(1); */
		/*       */
		visibility: visible;
		display: block;
	}
	.view.hide {
		/* transform: translate3d(-100%,0,0) scale(1);*/
		visibility: visible;
		display: block;
	}

	/* .view.active.drawerOpen{ 
		transform: translate3d(251px, 0px, 0px) scale(1);
	} */
	.views {
		display: block;
		position: absolute;
		height: 100%;
		min-height: 100%;
		width: 100%;
		min-width: 100%;
		top: 0;
		left: 0;
		transition-duration: 200ms;
		transform: translate3d(0px, 0px, 0px) scale(1);
	}
	.views.drawerOpen {
		transform: translate3d(251px, 0px, 0px) scale(1);
	}

	/* main :global(.hidem){
		transform: translate3d(-100%,0,0);
	}
	
	main :global(.showm){
		transform: translate3d(0,0,0);
	}

	main :global(.hided){
		transform: translate3d(100%,0,0);
	}
	main :global(.showd){
		transform: translate3d(-100%,0,0);
	} */

	:global(.animated) {
		animation-duration: 500ms;
		animation-fill-mode: both;
	}

	:global(.model-content svg) {
		width: 150px;
		height: 150px;
		fill: var(--user-color);
		color: var(--user-color);
	}

	@keyframes slideOut {
		from {
			transform: translate3d(0, 0, 0);
			visibility: visible;
		}

		to {
			transform: translate3d(-100%, 0, 0);
		}
	}

	:global(.slideOut) {
		animation-name: slideOut;
	}

	@keyframes slideOutBack {
		from {
			transform: translate3d(0, 0, 0);
			visibility: visible;
		}

		to {
			transform: translate3d(100%, 0, 0);
		}
	}

	:global(.slideOutBack) {
		animation-name: slideOutBack;
	}

	@keyframes slideIn {
		from {
			transform: translate3d(100%, 0, 0);
			visibility: visible;
		}

		to {
			transform: translate3d(0, 0, 0);
		}
	}

	:global(.slideIn) {
		animation-name: slideIn;
	}

	@keyframes slideInBack {
		from {
			transform: translate3d(-100%, 0, 0);
			visibility: visible;
		}

		to {
			transform: translate3d(0, 0, 0);
		}
	}

	:global(.slideInBack) {
		animation-name: slideInBack;
	}
</style>
